import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, Suspense as _Suspense, withCtx as _withCtx, KeepAlive as _KeepAlive, Transition as _Transition, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, " Loading... ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Outro = _resolveComponent("Outro")!
  const _component_Tutorial = _resolveComponent("Tutorial")!
  const _component_TutorialTester = _resolveComponent("TutorialTester")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component, route }) => [
        Component
          ? (_openBlock(), _createBlock(_Transition, {
              key: 0,
              name: route.meta.transition || 'fade',
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_KeepAlive, null, [
                  (_openBlock(), _createBlock(_Suspense, null, {
                    fallback: _withCtx(() => [
                      _hoisted_1
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                    ]),
                    _: 2
                  }, 1024))
                ], 1024))
              ]),
              _: 2
            }, 1032, ["name"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_Outro),
    _createVNode(_component_Tutorial),
    _createVNode(_component_TutorialTester)
  ], 64))
}